export const colorTheme = [
  { title: 'Rainbow', value: 'rainbow' },
  { title: 'Blues', value: 'Blues_r' },
  { title: 'RedYellowBlue', value: 'RdYlBu_r' },
];
